import { Component, Input, ViewEncapsulation } from '@angular/core';
import * as XLSX from 'xlsx';


@Component({
  selector: 'table-generator-cmp',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./table-generator.scss'],
  templateUrl: './table-generator.html'
})
export class TableGeneratorComponent {

  _tableInformation: any = null;
  columns: any[];
  @Input() public set tableInformation(value: any) {

    if (value) {
      this._tableInformation = value;

      if (value.information && value.information.length > 0) {
        this.columns = [];
        let columns = atob(value.Columns).split('*');

        columns.forEach((element) => {
          this.columns.push({ field: element, header: element });
        });
      }
    }
  }

  constructor() {

  }
  exportExcel() {
    const worksheet = XLSX.utils.json_to_sheet(this._tableInformation.information);
    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer);
  }

  saveAsExcelFile(buffer: any): void {
    const excelType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const data: Blob = new Blob([buffer], {
      type: excelType
    });
    var objectUrl = URL.createObjectURL(data);
    let a = document.createElement('a');
    a.href = objectUrl;
    a.download = `${this._tableInformation.QueryGenerator.Title}.xlsx`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
}